import WidgetInput from './WidgetInput';

import PropsText from './interfaces/PropsTextInterface';

export default class WidgetText extends WidgetInput<PropsText> {
    onChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(this.props.name, event.target.value, false);
    }
}
